import { render } from "./GibergAlagaro.vue?vue&type=template&id=1744a3fb&scoped=true"
import script from "./GibergAlagaro.vue?vue&type=script&lang=js"
export * from "./GibergAlagaro.vue?vue&type=script&lang=js"

import "./GibergAlagaro.vue?vue&type=style&index=0&id=1744a3fb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1744a3fb"]])

export default __exports__